import { z } from 'zod'

export const AccessibilityNeedsFormSchema = z
  .object({
    NON_ENGLISH_SPEAKING: z.boolean(),
    LANGUAGE_USED: z.string().min(1).optional(),
    PROVIDE_INTERPRETIVE_SERVICES: z.boolean(),
    CULTURAL_CONSIDERATIONS: z.union([z.literal('reports_no'), z.literal('reports_yes')]),
    CULTURAL_CONSIDERATIONS_DETAILS: z.string().min(1).optional(),
    ACCESS_ISSUES: z.union([z.literal('reports_no'), z.literal('reports_yes')]),
    ACCESS_ISSUES_DETAILS: z.string().min(1).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.NON_ENGLISH_SPEAKING && !data.LANGUAGE_USED) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['LANGUAGE_USED'],
        message: 'Language used is required if non-English speaking',
      })
    }

    if (data.CULTURAL_CONSIDERATIONS === 'reports_yes' && !data.CULTURAL_CONSIDERATIONS_DETAILS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['CULTURAL_CONSIDERATIONS_DETAILS'],
        message: 'Cultural considerations are required if patient reports cultural considerations',
      })
    }

    if (data.ACCESS_ISSUES === 'reports_yes' && !data.ACCESS_ISSUES_DETAILS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['ACCESS_ISSUES_DETAILS'],
        message: 'Access issues are required if patient reports access issues',
      })
    }
  })
